<template>
  <!-- 展示机台一天的疵点列表，现无使用 -->
  <div>
    <el-card>
    <div class="detable">
      <el-button type="danger" @click="defectDel()" style="margin:-15px 0 10px 10px">批量删除选定缺陷</el-button>
      <define-table :data="labelListData" @changePage="changePage" :pageInfo="pageInfo" :haveIndex="false"
                    @selection="deleteDefect" height="790px">
        <define-column columnType="selection"></define-column>
        <define-column columnType="index" label="序号" width="50px"></define-column>
        <define-column columnType="expand">
          <template v-slot="{ data }">
            <define-table :data="data.row.defectRecordItems" :height="`${data.row.defectRecordItems.length * 57 + 48}px`" :border="false" :haveIndex="false" :havePage="false">
              <define-column field="alias_name" label="缺陷别名"></define-column>
              <define-column field="confidence" label="缺陷分数"></define-column>
              <define-column field="indexOfCamera" label="相机编号"></define-column>
              <define-column field="indexOfLarghezza" label="门幅"></define-column>
              <define-column field="height" label="缺陷大小"></define-column>
            </define-table>
          </template>
        </define-column>
        <define-column label="缺陷数量" field="defectCount"></define-column>
        <define-column label="相机编号" field="defectRecordItems.indexOfCamera"></define-column>
        <define-column label="机台编号" field="productOrderItem.machine.number"></define-column>
        <define-column label="工单编号" field="productOrderItem.number" width="210px"></define-column>
        <define-column
          label="发生时间"
          :filter="(labelListData) => $filterTime(labelListData.createTime)"
        ></define-column>
        <define-column label="操作" v-slot="{ data }" width="240px">
          <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(data.row.id)"></el-button>
          </el-tooltip>
        </define-column>
      </define-table>
    </div>
    </el-card>
  </div>
</template>

<script>
import * as api from '@/api/factory/machine/defect'
export default {
  data () {
    return {
      labelListData: [],
      list: [],
      parameterList: {
        start: '',
        end: '',
        isToday: true,
        machineId: ''
      },
      deleteDefects: []
    }
  },
  methods: {
    showDefectItemDialog(defectRecordItems) {
      this.defectItemData = defectRecordItems
    },
    deleteDefect(val) {
      this.deleteDefects = val
    },
    defectDel() {
      this.$confirm('此操作将永久删除该缺陷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteDefects.forEach(item => {
          var data = { id: item.id }
          api.defectDel(data).then(res => {
            this.$Message.success(`缺陷 ${item.id} 删除成功`)
            this.changePage()
          }, rej => {
            this.$Message.error(`缺陷 ${item.id} 删除失败`)
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 判断时间
    // isTime() {
    //   var timestamp = new Date(new Date(new Date().toLocaleDateString()).getTime())
    //   console.log(timestamp)
    //   this.$request({
    //     url: '/DailyData/findNowList',
    //     method: 'GET',
    //     params: {
    //       page: 1,
    //       size: 99,
    //       direction: 'ASC',
    //       properties: 'number',
    //       factoryId: window.sessionStorage.getItem('factoryId')
    //     }
    //   }).then(res => {
    //     if (res.data.status === 200) {
    //       this.list = res.data.content
    //       this.list.forEach(item => {
    //         if (this.$route.params.id === item.machine.id) {
    //           if (item.updateTime < timestamp) {
    //             this.parameterList.isToday = false
    //             this.parameterList.end = item.updateTime
    //             this.parameterList.start = item.updateTime - 86400000
    //             console.log(this.parameterList.start + '    ' + this.parameterList.end + '     ')
    //           }
    //         }
    //       })
    //     } else {
    //       this.$Message.error(res.data.msg)
    //     }
    //   }).catch(() => {
    //     this.$Message.error('机台信息获取失败')
    //   })
    // },
    changePage () {
      this.parameterList.machineId = this.$route.params.id
      const params = this.parameterList
      api.changePage(params).then(res => {
        this.labelListData = res.data
        console.log(this.labelListData)
        for (const index in this.labelListData) {
          this.labelListData[index].defectRecordItems = JSON.parse(this.labelListData[index].defectRecordItems)
          // console.log(this.labelListData[index].defectRecordItems)
        }
      })
    },

    removeById(id) {
      this.$confirm('此操作将永久删除该缺陷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.removeById(id).then(res => {
          this.$Message.success('删除成功')
          this.changePage()
        }, rej => {
          this.$Message.error('删除失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },

  mounted () {
    this.changePage()
    // this.isTime()
  },
  watch: {
    chooseTimeValue (val, oldVal) {
      console.log(val)
    }
  }
}
</script>

<style lang='scss' scoped>
.el-button {
  margin-top: 10px;
}
.detable {
  margin: 10px 0 0 -10px;
}
.flexbox{
  display: flex;
  justify-content: space-between;
}
.defectNumberSum-elTag{
  margin-right: 10px;
  align-self: center;
}
</style>
